import type React from 'react'
import { cn } from '../../../shared/cn'

type TwoButtonsLayoutProps = {
  children: React.ReactNode
  className?: string
}

export function TwoButtonsLayout({ children, className }: TwoButtonsLayoutProps) {
  return (
    <div className={cn('flex flex-col flex-wrap gap-3 lg:flex-row lg:gap-x-8', className)}>
      {children}
    </div>
  )
}
